/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { FC, useState } from 'react';

import { CSSProperties, useTheme } from 'styled-components';

import { useFavoritesCoins } from '~/common/providers/favoritesCoins';
import { SPACING } from '~/common/layout-propertis/spacing';

import { Icon } from '../Icons';
import { Badge } from '../Badge';
import { Above } from '../Above';

export interface ICryptoBadgeProps {
  id?: number;
  name: string;
  logo: string;
  withoutBorder?: boolean;
  badgeStyle?: CSSProperties;
  withoutClick?: boolean;
  onlyImage?: boolean;
  variant: 'crypto' | 'stock';
}
export const CryptoBadge: FC<ICryptoBadgeProps> = ({
  id,
  name,
  logo,
  withoutBorder = false,
  withoutClick = false,
  badgeStyle,
}) => {
  const [hoverIcon, setHoverIcon] = useState<boolean>(false);
  const { toggleFavorite, favoritesIds: favorites } = useFavoritesCoins();
  const theme = useTheme();

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: SPACING._4 }}>
      {!!id && (
        <Above.Tooltip.Simple
          message={favorites.includes(id) ? 'Desfavoritar' : 'Favoritar'}
          background="neutral.950"
          orientation="horizontal"
        >
          <div
            {...(!withoutClick && {
              style: { cursor: 'pointer' },
            })}
            onMouseOver={() => setHoverIcon(true)}
            onMouseLeave={() => setHoverIcon(false)}
            onClick={(ev) => {
              toggleFavorite(id);
              ev.stopPropagation();
            }}
          >
            <Icon
              type={favorites.includes(id) ? 'star-fill' : 'star-line'}
              size={16}
              color={
                favorites.includes(id) || hoverIcon
                  ? theme.yellow[500]
                  : theme.neutral[0]
              }
            />
          </div>
        </Above.Tooltip.Simple>
      )}

      <Badge
        size="large"
        variant="outlined"
        imageUrl={logo}
        text={name}
        borderColor={withoutBorder ? 'transparent' : 'neutral.600'}
        textColor="neutral.0"
        color="grey"
        imageSize={24}
        style={badgeStyle}
      />
    </div>
  );
};
